import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function UpsellDetail() {
  const comparisons = [{
    sit: 'Tiempo muerto',
    sin: 'Explicas con palabras',
    con: 'Playbook Visual HD en 30 segundos'
  }, {
    sit: 'Pizarra táctica',
    sin: 'Dibujas en el suelo',
    con: '15 pizarras plastificadas listas'
  }, {
    sit: 'Comunicación con el armador',
    sin: 'En voz alta frente al rival',
    con: '20 señales que el rival no entiende'
  }, {
    sit: 'Análisis del rival',
    sin: 'Por intuición',
    con: 'Video-Scouting en 3 clips de 15 segundos'
  }, {
    sit: 'Compromiso del jugador',
    sin: 'Expectativas vagas',
    con: 'Tarjeta con 2 objetivos concretos'
  }, {
    sit: 'Lectura del rival',
    sin: 'Sin sistema formal',
    con: 'Mapa de Calor en 20 minutos'
  }, {
    sit: 'Reunión con directivos',
    sin: 'Sin datos ni presentación',
    con: 'Templates profesionales listos'
  }];
  const modules = [{
    title: 'M1: 🎯 El Playbook Visual HD',
    desc: '12 sistemas diagramados en HD. Imprime, plastifica y muestra en el tiempo muerto.'
  }, {
    title: 'M2: 📋 Pizarras Tácticas Imprimibles',
    desc: '15 diseños profesionales plastificables con marcador borrable.'
  }, {
    title: 'M3: 🤚 Sistema de Señales Visuales',
    desc: '20 señales manuales. El rival las ve. No las entiende.'
  }, {
    title: 'M4: 📱 Video-Scouting con el Celular',
    desc: '3 clips de 15 segundos igual a análisis completo del rival.'
  }, {
    title: 'M5: 📌 Tarjetas de Scout Individual',
    desc: 'Nombre, posición y 2 objetivos del partido. Compromiso +200%.'
  }, {
    title: 'M6: 🔥 Mapa de Calor del Rival',
    desc: '20 minutos de observación igual a radiografía defensiva completa.'
  }, {
    title: 'M7: 📊 Presentación Profesional al Club',
    desc: 'Templates de informe y presentación para directivos.'
  }];
  return <section className="py-20 px-4 bg-dark-DEFAULT border-t border-dark-border" data-id="element-292">
      <div className="max-w-5xl mx-auto" data-id="element-293">
        <div className="text-center mb-16" data-id="element-294">
          <h2 className="text-4xl md:text-5xl font-bebas mb-4" data-id="element-295">
            <span className="text-white" data-id="element-296">¿Qué agrega el </span>
            <span className="text-brand-DEFAULT" data-id="element-297">Kit Táctico Pro?</span>
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto" data-id="element-298">
            El sistema de competencia que hace que tu trabajo en cancha esté a
            la altura de tus conocimientos técnicos.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-dark-card border border-dark-border rounded-xl overflow-hidden mb-16" data-id="element-299">
          <div className="overflow-x-auto" data-id="element-300">
            <table className="w-full text-left border-collapse" data-id="element-301">
              <thead data-id="element-302">
                <tr className="bg-dark-DEFAULT border-b border-dark-border" data-id="element-303">
                  <th className="p-4 text-text-secondary font-medium" data-id="element-304">
                    Situación
                  </th>
                  <th className="p-4 text-text-secondary font-medium border-l border-dark-border bg-dark-card" data-id="element-305">
                    Sin Kit
                  </th>
                  <th className="p-4 text-brand-DEFAULT font-bold border-l border-dark-border bg-dark-border" data-id="element-306">
                    Con Kit Táctico Pro
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-307">
                {comparisons.map((row, index) => <tr key={index} className="border-b border-dark-border last:border-0" data-id="element-308">
                    <td className="p-4 text-white font-medium" data-id="element-309">{row.sit}</td>
                    <td className="p-4 text-text-secondary border-l border-dark-border bg-dark-card text-sm" data-id="element-310">
                      <div className="flex items-start" data-id="element-311">
                        <XIcon size={16} className="text-text-secondary mr-2 mt-0.5 flex-shrink-0" data-id="element-312" />
                        {row.sin}
                      </div>
                    </td>
                    <td className="p-4 text-white border-l border-dark-border bg-dark-border text-sm" data-id="element-313">
                      <div className="flex items-start" data-id="element-314">
                        <CheckIcon size={16} className="text-brand-DEFAULT mr-2 mt-0.5 flex-shrink-0" data-id="element-315" />
                        {row.con}
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        {/* Modules */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-316">
          {modules.map((mod, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-card border border-dark-border p-6 rounded-xl" data-id="element-317">
              <h4 className="text-brand-DEFAULT font-bold mb-2" data-id="element-318">{mod.title}</h4>
              <p className="text-text-secondary text-sm leading-relaxed" data-id="element-319">
                {mod.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}